module.exports = __webpack_public_path__ + "assets/e76bfcace4da4aacfd4d74220de65bde.png";